import toast from "react-hot-toast";
import { Campaign } from "../../types";
import { baseUrl } from "./baseUrl";

export async function fetchAllPaymentLinks(): Promise<any> {
  const all: any = [];
  let page = 1;
  let hasNext = true;

  try {
    while (hasNext) {
      const url = new URL(
        `${baseUrl}/admin/paymentLinks`
      );
      url.searchParams.set("page", String(page));

      const res = await fetch(url.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("admin_token")}`,
        },
      });

      const payload = (await res.json()) as {
        success: boolean;
        message: string;
        data: any;
        pagination: {
          hasNextPage: boolean;
        };
      };

      if (!res.ok) {
        const m = payload.message?.toLowerCase();
        if (
          m === "invalid token" ||
          m === "jwt malformed" ||
          m === "jwt expired"
        ) {
          sessionStorage.removeItem("admin_token");
          toast.error("Session expired, please sign in again");
          window.location.href = "/auth/sign-in";
          return Promise.reject(new Error("Unauthorized"));
        }
        throw new Error(payload.message || `HTTP ${res.status}`);
      }

      if (!payload.success) {
        throw new Error(payload.message || "Failed to fetch campaigns");
      }

      all.push(...payload.data);

      hasNext = payload.pagination.hasNextPage;
      page += 1;
    }

    return all;
  } catch (err) {
    console.error("Error fetching all campaigns:", err);
    throw err;
  }
}
export async function fetchAllPaymentLinkDonations(): Promise<any> {
  const all: any = [];
  let page = 1;
  let hasNext = true;

  try {
    while (hasNext) {
      const url = new URL(
        `${baseUrl}/admin/paymentLinkDonations`
      );
      url.searchParams.set("page", String(page));

      const res = await fetch(url.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("admin_token")}`,
        },
      });

      const payload = (await res.json()) as {
        success: boolean;
        message: string;
        data: any;
        pagination: {
          hasNextPage: boolean;
        };
      };

      if (!res.ok) {
        const m = payload.message?.toLowerCase();
        if (
          m === "invalid token" ||
          m === "jwt malformed" ||
          m === "jwt expired"
        ) {
          sessionStorage.removeItem("admin_token");
          toast.error("Session expired, please sign in again");
          window.location.href = "/auth/sign-in";
          return Promise.reject(new Error("Unauthorized"));
        }
        throw new Error(payload.message || `HTTP ${res.status}`);
      }

      if (!payload.success) {
        throw new Error(payload.message || "Failed to fetch campaigns");
      }

      all.push(...payload.data);

      hasNext = payload.pagination.hasNextPage;
      page += 1;
    }

    return all;
  } catch (err) {
    console.error("Error fetching all campaigns:", err);
    throw err;
  }
}
